var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_950_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10H19.4201C20.0026 10 20.4618 10.4959 20.4172 11.0767L19.571 22.077C19.5516 22.3281 19.4381 22.5627 19.2533 22.7338C19.0685 22.9049 18.8259 23 18.574 23H12.426C12.1736 23.0007 11.9302 22.906 11.7448 22.7348C11.5593 22.5636 11.4454 22.3287 11.426 22.077L11 17",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86344 22.5332C5.11215 22.8094 5.45928 22.977 5.83023 23H8.50023M4.65723 15.4062C4.65723 15.4062 4.65723 13.3757 4.65723 11.926C4.65723 8.53 6.50023 5.329 6.50023 4V2C6.50023 1.44772 6.94794 1 7.50023 1H9.50023C10.0525 1 10.5002 1.44772 10.5002 2V3.91936C10.5002 3.97303 10.5045 4.02664 10.5134 4.07956C10.6824 5.08216 10.9662 6.06209 11.3592 7L12.0002 8.5",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 23L23 1",
    stroke: "#FCFCFC",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_950_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.6fb7c6ea9972b8ff6a28399b8329ae6f.svg";
export { ForwardRef as ReactComponent };